import { useEffect, useRef, useState } from "react";

// Keep mounted after the first approach, preserving shelf state when scrolling back.
export default function useNearViewport({
  rootRef,
  margin = "500px 0px",
  eager = false
} = {}) {
  const ref = useRef(null);
  const [ready, setReady] = useState(
    () => eager || typeof IntersectionObserver === "undefined"
  );
  useEffect(() => {
    if (ready) return;
    if (eager) {
      setReady(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setReady(true);
          observer.disconnect();
        }
      },
      { root: rootRef?.current || null, rootMargin: margin }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ready, eager, rootRef, margin]);
  return [ref, ready];
}
